import React, { useState } from "react";
import { Flex, Box, Button  } from "@chakra-ui/react";
import { useAppContext } from "../../contexts/AppContext";
import useTasks from "../../hooks/useTasks";
import TasksTable from "./TasksTable";
import {  Plus } from "lucide-react";

const CompletedTasks = ({ openTaskDrawer }) => {

  const { tasks } = useAppContext();
  const { handleCheckboxChange } = useTasks();
    const [filters, setFilters] = useState({});
  

  return (
    <Flex direction="column" p={0} w={"100%"} gap={8}>
        <Flex
        justifyContent="space-between"
        direction={{ lg: "row", base: "column" }}
        gap={4}>
        <Flex align={"center"} gap={4}>
          <h1>Completed tasks</h1>
        </Flex>
        <Flex gap={1}>
          <Button
            onClick={() => openTaskDrawer()}
            w={"fit-content"}
            leftIcon={<Plus size={16} />}>
            Add a new task
          </Button>
        </Flex>
      </Flex>
  {tasks.some((task) => task.completed) ? (
                <TasksTable
                  tasks={tasks.filter((task) => task.completed)}
                  filters={filters}
  setFilters={setFilters}
                  handleCheckboxChange={handleCheckboxChange}
                  onRowClick={(task) => openTaskDrawer(task)}
                />
              ) : (
                <Box textAlign="center" mt={4} color="gray.500">
                  No completed tasks
                </Box>
  )}
  </Flex>
  );
};

export default CompletedTasks;
